"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _EventListOverview = _interopRequireDefault(require("./EventListOverview"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EventOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EventOverview, _Component);

  var _super = _createSuper(EventOverview);

  function EventOverview() {
    (0, _classCallCheck2.default)(this, EventOverview);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(EventOverview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window === 'undefined') {
        return;
      }

      (function (history) {
        var pushState = history.pushState;

        window.history.pushState = function (state) {
          if (typeof window.history.onpushstate === 'function') {
            window.history.onpushstate({
              state: state
            });
          } // @ts-expect-error


          return pushState.apply(history, arguments);
        };
      })(window.history);

      window.history.onpushstate = function () {// pushstate is async event, without setTimeout it is getting previous state
        // window.setTimeout(async () => {
        // }, 0)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$upcomingE = _this$props.upcomingEvents,
          upcomingEvents = _this$props$upcomingE === void 0 ? [] : _this$props$upcomingE,
          _this$props$pastEvent = _this$props.pastEvents,
          pastEvents = _this$props$pastEvent === void 0 ? [] : _this$props$pastEvent;
      var hasUpcomingEvents = upcomingEvents && upcomingEvents.length > 0;
      var hasPastEvents = pastEvents && pastEvents.length > 0;
      return (0, _preact.h)("div", null, hasUpcomingEvents && (0, _preact.h)("div", {
        className: "event-list"
      }, (0, _preact.h)("h4", {
        className: "event-past-header"
      }, (0, _preact.h)(_phrase.default, {
        p: "events.title.upcoming",
        m: "Forum"
      })), (0, _preact.h)(_EventListOverview.default, {
        eventList: upcomingEvents,
        className: "event-upcoming-wrapper"
      })), hasPastEvents && (0, _preact.h)("div", {
        className: "event-list"
      }, (0, _preact.h)("h4", {
        className: "event-past-header"
      }, (0, _preact.h)(_phrase.default, {
        p: "events.title.past",
        m: "Forum"
      })), (0, _preact.h)(_EventListOverview.default, {
        eventList: pastEvents,
        className: "event-upcoming-wrapper qa-event-past-wrapper"
      })));
    }
  }]);
  return EventOverview;
}(_preact.Component);

var _default = EventOverview;
exports.default = _default;